import { LoadingOverlay } from 'foundations-components/transitional/components/LoadingOverlay';
import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { jsx as _jsx } from "react/jsx-runtime";
const ReportingAnalyzeTab = Loadable({
  loader: () => import( /* webpackChunkName: "reporting-analyze-tab" */'FormsUI/components/dashboard/ReportingAnalyzeTab'),
  LoadingComponent: ({
    pastDelay
  }) => {
    return pastDelay ? /*#__PURE__*/_jsx(LoadingOverlay, {
      contextual: true
    }) : null;
  }
});
export default ReportingAnalyzeTab;